import { Component, Injector, OnInit, OnDestroy } from '@angular/core';
import { FormMeta } from '../../data/FormMeta';
import { Subscription } from 'rxjs';
import { MerchantsComponent } from '../merchants/merchants.component';

@Component({
  selector: 'app-merchant-forms',
  templateUrl: './merchant-forms.component.html',
  styleUrls: ['./merchant-forms.component.css']
})
export class MerchantFormsComponent
  extends MerchantsComponent
  implements OnInit, OnDestroy
{
  file: File = null;
  error = '';
  merchantForms: FormMeta[] = [];
  pagedMerchantForms: FormMeta[] = [];
  itemsPerPage = 10;
  page = 1;
  uploading = false;
  retrievingForms = false;
  subscriptions: Subscription[] = [];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.getMerchantForms();
  }

  setItemsPerPage(evt) {
    const itemsPerPage = evt.target.value;
    this.itemsPerPage = itemsPerPage;
    this.pageSet(this.page, true);
  }

  getMerchantForms() {
    const merchant = this.merchantService.getSelectedMerchant();
    let stripAccount = null;
    this.retrievingForms = true;
    this.subscriptions.push(
      this.getMerchantAccount(merchant).subscribe(
        (merchDetails) => {
          stripAccount = merchDetails.customerAccounts[0];
          this.subscriptions.push(
            this.cardHolderService
              .getMerchantForms(stripAccount.account)
              .subscribe(
                (forms: FormMeta[]) => {
                  this.merchantForms = forms;
                  this.merchantForms.sort((a: any, b: any) => {
                    const useDateA = new Date(a.formDate).getTime();
                    const useDateB = new Date(b.formDate).getTime();
                    return useDateB - useDateA;
                  });
                  this.pageSet(1, false);
                  this.retrievingForms = false;
                },
                (_) => {
                  this.messageService.error(
                    'There was an error retrieving merchant forms'
                  );
                  this.retrievingForms = false;
                }
              )
          );
        },
        (err) => {
          this.retrievingForms = false;
        }
      )
    );
  }

  fileSelected(file: File) {
    this.file = file;
  }

  cancel() {
    this.error = '';
    this.file = null;
  }

  setError(error: string) {
    this.error = error;
  }

  pageSet(page, scrollTop = true) {
    this.page = page;
    this.paginate();
    if (scrollTop) {
      window.scrollTo(0, 300);
    }
  }

  paginate() {
    if (this.merchantForms.length <= this.itemsPerPage) {
      this.pagedMerchantForms = this.merchantForms;
    } else {
      this.pagedMerchantForms = this.merchantForms.slice(
        (this.page - 1) * this.itemsPerPage,
        (this.page - 1) * this.itemsPerPage + this.itemsPerPage
      );
    }
  }

  uploadForm() {
    this.uploading = true;
    const merchant = this.merchantService.getSelectedMerchant();
    let stripAccount = null;
    this.getMerchantAccount(merchant).subscribe((merchDetails) => {
      stripAccount = merchDetails.customerAccounts[0];
      const file = this.file;
      this.cardHolderService.uploadForm(stripAccount.account, file).subscribe(
        () => {
          this.uploading = false;
          this.file = null;
          this.messageService.success('The Form was Uploaded Successfully');
          this.getMerchantForms();
        },
        (data) => {
          this.uploading = false;
          this.messageService.error('There was an error in upload');
        }
      );
    });
  }

  getEnrollmentForm(form: FormMeta) {
    this.cardHolderService
      .downloadEnrollmentPDF(form.idSeq, form.formSeq, form.fileName)
      .subscribe(
        (data) => {
          const pdfFile = new Blob([data], { type: 'application/pdf' });
          const pdfURL = URL.createObjectURL(pdfFile);
          window.open(pdfURL);
        },
        (error) => this.messageService.error(error.message)
      );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
